import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 电表列表
 * @param {Object} data
 * @returns
 */
export function pageElectricMeter (data) {
  return request.post('/ooh-invest/electricMeter/pageElectricMeter', qs.stringify(data))
}
/**
 * 新增电表
 * @param {Object} data
 * @returns
 */
export function saveMeter (params) {
  return request({
    url: '/ooh-invest/electricMeter/saveMeter',
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  })
}
/**
 * 删除电表
 * @param {Object} data
 * @returns
 */
export function deleteByMeterRecordId (data) {
  return request.post('/ooh-invest/electricMeter/deleteByMeterRecordId', qs.stringify(data))
}
